export default __webpack_public_path__ + "static/media/no-progress-emoticon.5f7203c2.png";